var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{staticClass:"btn-total-load",class:_vm.className,attrs:{"disabled":_vm.disabled,"label":_vm.text,"false-value":0,"true-value":1},model:{value:(_vm.filters.total_load),callback:function ($$v) {_vm.$set(_vm.filters, "total_load", $$v)},expression:"filters.total_load"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a8f1a80","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/panelV2/ActualButton.vue
// module id = null
// module chunks = 